<template>
  <v-list-item
    @click.prevent="abrirDialogCotacaoPedido()"
    :disabled="getProdutosSelecionadosCarrinho == 0"
  >
    <v-icon size="19">mdi-format-list-checks</v-icon>
    <p class="ma-0 ml-2">Abrir cotação</p>

    <Cotacao :pedido="pedido" ativacao_dialog_personalizada="abrir" />
  </v-list-item>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Cotacao from "./Index.vue";

export default {
  components: { Cotacao },
  props: {
    pedido: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getProdutosSelecionadosCarrinho: "CotacaoCarrinhoCompra/GET_PRODUTOS_SELECIONADOS_CARRINHO"
    })
  },
  methods: {
    ...mapMutations({
      SET_DIALOG_ABRIR_COTACAO: "CotacaoCarrinhoCompra/SET_DIALOG_ABRIR_COTACAO"
    }),
    abrirDialogCotacaoPedido() {
      this.SET_DIALOG_ABRIR_COTACAO(true);
    }
  }
}
</script>

<style>

</style>
